<!-- <p>token-expired-dialog works!</p> -->
<div class="token-expired-container">
  <div class="aumye-header">Authentication Required</div>
  <div class="dialog-content">
    <p>
      Your session has <b>expired</b>. Please re-authenticate to continue using
      the application.
    </p>
    <mat-divider></mat-divider>
    <p>
      <i>Routing to Login Screen : </i><b>{{ countdown }}</b> seconds
    </p>
  </div>
</div>
